import React, { Component } from 'react'
import { Modal, DatePickerView, Flex } from 'antd-mobile'
import df from 'dateformat'

export default class RangeDatePicker extends Component {
  constructor(props) {
    super(props)
    const defaultValues = this.props.defaultValue
    let defaultStartDate
    let defaultEndDate

    if (Array.isArray(defaultValues)) {
      defaultStartDate = defaultValues[0]
      defaultEndDate = defaultValues[1] ? defaultValues[1] : defaultStartDate
    } else if (defaultValues) {
      defaultStartDate = defaultEndDate = defaultValues
    } else {
      defaultStartDate = new Date()
      defaultEndDate = new Date()
    }

    if (defaultStartDate.getTime() > defaultEndDate.getTime()) {
      let temp = defaultStartDate
      defaultStartDate = defaultEndDate
      defaultEndDate = temp
    }
    this.state = {
      selectedDate: 0, //0：选中开始时间 1：选中结束时间
      startDate: defaultStartDate,
      endDate: defaultEndDate
    }
  }
  componentWillReceiveProps(){
    const defaultValues = this.props.defaultValue
    let defaultStartDate
    let defaultEndDate

    if (Array.isArray(defaultValues)) {
      defaultStartDate = defaultValues[0]
      defaultEndDate = defaultValues[1] ? defaultValues[1] : defaultStartDate
    } else if (defaultValues) {
      defaultStartDate = defaultEndDate = defaultValues
    } else {
      defaultStartDate = new Date()
      defaultEndDate = new Date()
    }

    if (defaultStartDate.getTime() > defaultEndDate.getTime()) {
      let temp = defaultStartDate
      defaultStartDate = defaultEndDate
      defaultEndDate = temp
    }
    this.setState({
      startDate: defaultStartDate,
      endDate: defaultEndDate
    })
  }
  onCancel = () => {
    if (typeof this.props.onCancel === 'function') {
      this.props.onCancel()
    }
  }
  onSubmit = () => {
    if (typeof this.props.onConfirm === 'function') {
      if (this.state.startDate.getTime() < this.state.endDate.getTime()) {
        this.props.onConfirm(this.state.startDate, this.state.endDate)
      } else {
        this.props.onConfirm(this.state.endDate, this.state.startDate)
      }
    }
  }
  render() {
    const props = this.props
    const FlexItem = Flex.Item
    const { startDate, endDate, selectedDate } = this.state
    return (
      <Modal
        className="custom-date-picker"
        popup
        animationType="slide-up"
        visible={props.visible}
      >
        <div className="custom-date-picker-header">
          <div className="btn" onClick={this.onCancel}>
            取消
          </div>
          <div className="btn" onClick={this.onSubmit}>
            确定
          </div>
        </div>
        <div className="range-container">
          <div
            className={selectedDate === 0 ? 'date-label active' : 'date-label'}
            onClick={() => {
              this.setState({ selectedDate: 0 })
            }}
          >
            {df(startDate, 'yyyy-mm-dd')}
          </div>
          至
          <div
            className={selectedDate === 1 ? 'date-label active' : 'date-label'}
            onClick={() => {
              this.setState({ selectedDate: 1 })
            }}
          >
            {df(endDate, 'yyyy-mm-dd')}
          </div>
        </div>
        <DatePickerView
          value={selectedDate === 0 ? startDate : endDate}
          onChange={val => {
            if (selectedDate === 0) {
              this.setState({
                startDate: val
              })
            } else {
              this.setState({
                endDate: val
              })
            }
          }}
          mode="date"
        />
      </Modal>
    )
  }
}
